enum LoadingState {
  NO_DATA = "NoData",
  LOADING = "Loading",
  RESOLVED = "Resolved",
  REJECTED = "Rejected",
}

export default LoadingState;
